import { render, staticRenderFns } from "./InputBirthdayPanel.vue?vue&type=template&id=f144a31c&"
import script from "./InputBirthdayPanel.vue?vue&type=script&lang=js&"
export * from "./InputBirthdayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports